module.exports = __webpack_public_path__ + "img/thumb-003-01.2683639a.png";